"use client";
import { VoteContainer } from "./container/VoteContainer";

const Vote = () => {
  return <VoteContainer />;
};

export default Vote;
